import React, { createContext, useContext, useEffect, useState } from "react";

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Raw fetch on purpose: this provider is mounted in index.js above <App>, and
    // therefore above <Admin>, so there is no dataProvider in context here.
    // Using it would mean moving the provider inside <Admin>. dataProvider.js
    // fetches this same endpoint at module level for the same reason.
    const fetchTranslations = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/translations/es`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch translations");
        }
        const data = await response.json();
        setTranslations(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchTranslations();
  }, []);

  const value = {
    translations,
    loading,
    error,
  };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (context === undefined) {
    throw new Error("useTranslation must be used within a TranslationProvider");
  }
  return context;
};
